export default __webpack_public_path__ + "static/media/background_hand.75dbdbd4.jpg";